import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

import { computed } from "vue";
import { versionToString } from "@/util";
import { projectStore } from "@/hooks";
import { PanelCard, Typography } from "@/components/common";


/**
 * Displays the project description.
 */
const __default__ = {
  name: "ProjectOverviewDisplay",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    hideTitle: { type: Boolean },
    hideOverflow: { type: Boolean },
    borderless: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

// const editMode = computed(() => appStore.popups.editProject);
// const editedIdentifier = computed(() => identifierSaveStore.editedIdentifier);

const displayDescription = computed(
  () =>
    // If there is no specification, show the description.
    !projectStore.project.specification &&
    // If the description is the same as the specification, hide it.
    projectStore.project.description.length !==
      projectStore.project.specification?.length
);

const name = computed(() => projectStore.project.name || "Project Overview");

const versionLabel = computed(
  () => `Version ${versionToString(projectStore.project.projectVersion)}`
);

const description = computed(
  () =>
    projectStore.project.description ||
    "This project does not have a description."
);

const specification = computed(() => projectStore.project.specification);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(PanelCard), {
    title: props.hideTitle ? undefined : name.value,
    borderless: props.borderless
  }, _createSlots({
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "overflow-auto",
        style: _normalizeStyle(_ctx.hideOverflow ? 'max-height: 40vh' : '')
      }, [
        (!!specification.value && displayDescription.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 0,
              variant: "caption",
              value: "Description"
            }))
          : _createCommentVNode("", true),
        (displayDescription.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 1,
              ep: "p",
              variant: "expandable",
              value: description.value,
              "default-expanded": "",
              "collapse-length": 0,
              copyable: ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true),
        (!!specification.value && displayDescription.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 2,
              variant: "caption",
              value: "Specification"
            }))
          : _createCommentVNode("", true),
        (!!specification.value)
          ? (_openBlock(), _createBlock(_unref(Typography), {
              key: 3,
              ep: "p",
              variant: "expandable",
              value: specification.value,
              "default-expanded": "",
              "collapse-length": 0,
              copyable: ""
            }, null, 8, ["value"]))
          : _createCommentVNode("", true)
      ], 4)
    ]),
    _: 2
  }, [
    (!props.hideTitle)
      ? {
          name: "title-actions",
          fn: _withCtx(() => [
            _createVNode(_unref(Typography), {
              secondary: "",
              value: versionLabel.value
            }, null, 8, ["value"])
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["title", "borderless"]))
}
}

})